import React from "react"
import About from "../base-pages/about"

const AboutCN = () => {
  return <About lang="cn" />
}

export default AboutCN
